import React, { useEffect, useState, useRef } from 'react'
import styles from './styles.module.scss'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'


const WeInMedia = ({ checkDomenNameState }) => {
  const _domenWork = 'career.generium.ru'
  const [weInMedia, setWeInMedia] = useState([])

  let _protocol = window.location.protocol

  if (window.location.hostname.indexOf(_domenWork) != -1) {
    checkDomenNameState = window.location.hostname
  }

  const getWeInMedia = async () => {
    try {
      const result = await axios({
        method: 'get',
        url: `${_protocol}//${checkDomenNameState}/api/v1/content/media`
      })
      setWeInMedia(result.data)
    } catch (e) {
      toast.error('Ошибка загрузки направлений')
    }
  }

  useEffect(() => {
    getWeInMedia()
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
      </div>
      <div className={styles.right}>
        <div className={styles.right_wrapper}>
          <p className={styles.title}>Мы в СМИ</p>
          <div className={styles.list}>
            {weInMedia !== undefined ? 
              weInMedia
                .map((item, index) => (index < 2 &&
                  <>
                    <a className={styles.item} key={item.id} href={item.url} target='_blank'>
                      <img className={styles.item_image} src={item.img} />
                      <p className={styles.item_p}>{item.title}</p>
                    </a>
                  </>
                )) : ""}
            <Link to='/media' className={styles.button + ' ' + styles["button--transparent"]}>
              Все публикации <span>&rarr;</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WeInMedia
